module.exports = __webpack_public_path__ + "img/1312707548.2ec62fe3.jpg";